import React from 'react';

type SplitMinuteTimeInputProps = {
  value?: string;
  initialTime?: string;
  onChange?: (time: string) => void;
  date?: Date;
  includeSeconds?: boolean;
  onDateTimeChange?: (date: Date) => void;
};

const hours = Array.from({ length: 24 }, (_, hour) => String(hour).padStart(2, '0'));
const minutes = Array.from({ length: 60 }, (_, minute) => String(minute).padStart(2, '0'));

const SplitMinuteTimeInput: React.FC<SplitMinuteTimeInputProps> = ({ value = '', initialTime = '', onChange, date, includeSeconds = false, onDateTimeChange }) => {
  const match = /^(\d{2}):(\d{2})(?::\d{2})?$/.exec(value || initialTime);
  const hour = match?.[1] ?? '';
  const minute = match?.[2] ?? '';
  const second = date && !isNaN(date.getTime()) ? String(date.getSeconds()).padStart(2, '0') : '00';
  const changeTime = (nextHour: string, nextMinute: string, nextSecond = second) => {
    if (includeSeconds) {
      // react-datepickerのcustomTimeInput標準処理は秒を捨てるため、日時を直接返す。
      const next = date && !isNaN(date.getTime()) ? new Date(date) : new Date();
      next.setHours(Number(nextHour), Number(nextMinute), Number(nextSecond), 0);
      onDateTimeChange?.(next);
    } else {
      onChange?.(`${nextHour}:${nextMinute}`);
    }
  };

  return (
    <div className="split-minute-time-input">
      <select
        aria-label="時"
        value={hour}
        onChange={(event) => changeTime(event.target.value, minute || '00')}
      >
        <option value="" disabled>時</option>
        {hours.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
      <span>:</span>
      <select
        aria-label="分"
        value={minute}
        disabled={!hour}
        onChange={(event) => changeTime(hour, event.target.value)}
      >
        <option value="" disabled>分</option>
        {minutes.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
      {includeSeconds && (
        <>
          <span>:</span>
          <select aria-label="秒" value={second} disabled={!hour} onChange={(event) => changeTime(hour, minute || '00', event.target.value)}>
            {minutes.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
        </>
      )}
    </div>
  );
};

export default SplitMinuteTimeInput;
